import { getBasePath } from '../../utils/config';
import { safeJsonParse } from 'api/utils/fetchHelpers';
import {
  IgetTransactionsAPIBody,
  IgetDeliveryNotesColumnsAPIResponse,
  IgetDeliveryNotesItemAPIResponse,
} from './transactions.response.interface';

export const getDeliveryNotesItemsAPI = async (
  body: IgetTransactionsAPIBody,
  signal: AbortSignal,
  token: string
): Promise<IgetDeliveryNotesItemAPIResponse> => {
  const params = {
    signal: signal,
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
  };
  const response = await fetch(`${getBasePath()}/operations/delivery_note`, params);
  return await safeJsonParse(response);
};

export const getDeliveryNotesColumnsAPI = async (
  token: string
): Promise<IgetDeliveryNotesColumnsAPIResponse> => {
  const params = {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  };
  const response = await fetch(`${getBasePath()}/operations/delivery_note`, params);
  return await safeJsonParse(response);
};

export const getBillsItemsAPI = async (
  body: IgetTransactionsAPIBody,
  signal: AbortSignal,
  token: string
): Promise<IgetDeliveryNotesItemAPIResponse> => {
  const params = {
    signal: signal,
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
  };
  const response = await fetch(`${getBasePath()}/operations/bills`, params);
  return await safeJsonParse(response);
};

export const getBillsColumnsAPI = async (
  token: string
): Promise<IgetDeliveryNotesColumnsAPIResponse> => {
  const params = {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  };
  const response = await fetch(`${getBasePath()}/operations/bills`, params);
  return await safeJsonParse(response);
};

export const getOrdersItemsAPI = async (
  body: IgetTransactionsAPIBody,
  signal: AbortSignal,
  token: string
): Promise<IgetDeliveryNotesItemAPIResponse> => {
  const params = {
    signal: signal,
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
  };
  const response = await fetch(`${getBasePath()}/operations/orders`, params);
  return await safeJsonParse(response);
};

export const getOrdersColumnsAPI = async (
  token: string
): Promise<IgetDeliveryNotesColumnsAPIResponse> => {
  const params = {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  };
  const response = await fetch(`${getBasePath()}/operations/orders`, params);
  return await safeJsonParse(response);
};
